// services/PermissionService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

// LIST (paginated)
export function getPermissions(params = {}) {
    return api.get(ENDPOINTS.PERMISSIONS.BASE, { params });
}

// GET ONE
export function getPermissionById(id) {
    return api.get(ENDPOINTS.PERMISSIONS.BY_ID(id));
}

// CREATE
export function createPermission(payload) {
    return api.post(ENDPOINTS.PERMISSIONS.BASE, payload);
}

// UPDATE
export function updatePermission(id, payload) {
    return api.patch(ENDPOINTS.PERMISSIONS.BY_ID(id), payload);
}

// DELETE
export function deletePermission(id) {
    return api.delete(ENDPOINTS.PERMISSIONS.BY_ID(id));
}

// RESTORE
export function restorePermission(id) {
    return api.post(`${ENDPOINTS.PERMISSIONS.BY_ID(id)}/restore`);
}
